module.exports = __webpack_public_path__ + "img/069.653c4866.jpg";